import gql from 'graphql-tag';

export const updateCompanyConfigurationMutation = gql`
    mutation  updateCompanyConfiguration($updateCompanyConfigurationInput: UpdateCompanyConfigurationInput!) {
        updateCompanyConfiguration(updateCompanyConfigurationInput: $updateCompanyConfigurationInput)
    }`;
